import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const usageTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default usageTypeConfig;
